<template lang="pug">
pEmbed(:urlProps="urlProps")
</template>

<script>
import clarity from '@/plugins/clarity'
import pEmbed from '@/components/firebase'

clarity.install()

export default {
  name: 'App',
  components: {
    pEmbed
  },
  props: {
    urlProps: {
      type: String,
      default: ''
    }
  }
};
</script>

<style>
@import '@/assets/playercustom.css';
</style>
